import { createFileRoute } from "@tanstack/react-router";

import { PurchaseMetalTransaction } from "../-components/Purchase/PurchaseMetal";

export const Route = createFileRoute("/_authenticated/trade/purchase/")({
  component: PurchaseMetalTransaction,
  context: () => ({ permissions: "trade.purchase" }),
});
